import request from '@/utils/request'
import { API_ENDPOINTS } from '@/constants/api'

export const getUserInfo = () => {
  return request(API_ENDPOINTS.GET_USER_INFO)
}